import { useCallback } from 'react';
import { useQuery } from '@tanstack/react-query';
import { hasPermission, readMyIdentity } from '@/lib/events';

/**
 * Whether the signed-in staff member holds a permission grant (superadmins
 * hold every one). While the identity loads the answer is no, so anything
 * behind a grant stays hidden rather than flashing up.
 *
 * @returns A lookup from permission key to whether it is held.
 */
export function usePermissionLookup(): (permission: string) => boolean {
  const identity = useQuery({ queryKey: ['my-identity'], queryFn: ({ signal }) => readMyIdentity(signal), staleTime: 5 * 60_000 });
  return useCallback((permission: string) => hasPermission(identity.data, permission), [identity.data]);
}
